
module.exports = Backbone.Model.extend({
    defaults: {
        involuntaryCancellationPNRs: {},
        renderPNRCards: true,
    },

    setAirlineListFromCMSKey(modelProp, key = '') {
        key && this.set(modelProp, key.split(/[#\s,]/));
    },
});
